<div class="accordion" [id]="parentId" [style.gap]="gap">
	<ng-content></ng-content>
</div>
